import { Button } from "@omni/ui/components/Button/button.component";
import { SyntheticEvent } from "react";

type WishlistExchangeButtonComponent = {
    sku: string;
    currentWishlistId: string;
    onMove?: (sku: string, currentWishlistId: string) => void;
};

const WishlistExchangeButtonComponent = ({
    sku,
    currentWishlistId,
    onMove
}: WishlistExchangeButtonComponent) => {
    const handleOnButtonClick = (event: SyntheticEvent<HTMLButtonElement>) => {
        event.preventDefault();
        event.stopPropagation();
        onMove?.(sku, currentWishlistId);
    };

    return (
        <Button
            color="link"
            type="button"
            className="d-block"
            onClick={handleOnButtonClick}
        >
            <i className="las la-exchange-alt"></i>
        </Button>
    );
};

export default WishlistExchangeButtonComponent;
